import session from '../api/session';

/* 
***********************************************

Mixin permettant de ne gérer qu'un seul objet

Voir méthode updateModelObject() pour la gestion des properties de type File

***********************************************
*/ 

export var mixin_one_ajax = ({
  props: ['cv_id'],
  data: function() {
    return {
      file_names: ['preview_img'],
      api_url: 'none',
      api_url_post: 'none',
      modelObject: {},
      // newModelObject() est toujours surdéfini dans le composant
      // qui appelle ce mixin
      newModelObject: function() {
          // Inutile de renseigner l'objet car il est surdéfini par les composants
          // qui appellent ce mixin.
          return { 
          }
      },
      isLoading: false,
    }
  },
  methods: {
    getModelObject() {
      var req_url = this.api_url 
      session.get(req_url)
        .then((response) => {
          this.modelObject = response.data;
          this.isLoading = false;
          console.log('GET CALLED : ' + req_url);
          console.log(response)
        })
        .catch((err) => {
          this.isLoading = false;
          if (err.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log('======= getModelObject error in response =======')
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
          } else if (err.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log('======= getModelObject error in request =======')
            console.log(err.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('======= getModelObject error in else =======')
            console.log('Err', err.message);
          }
        })
    },

    addModelObject: function() {
       this.isLoading = true;
        console.log("Ajout d'une instance objectModel : ");
        console.log(this.newModelObject());
        var payload = this.newModelObject();
        // gestion de la protection csrf :
        // session.defaults.xsrfCookieName = 'csrftoken'
        // session.defaults.xsrfHeaderName = 'X-CSRFToken'
        session.post(this.api_url_post, payload)
        // NOTE!!!! IMPORTANT!!!
        // On utilise un POST sans spécifier le nom de l'objet final. Le server se charge de créer l'objet.
        // Avec un PUT, on spécifie l'url compléte avec le nom de l'objet.
        // C'est pour cela que nous devons avoir 2 URL : une complete (api_url) et l'autre (api_url_post).
        .then((response) => {
          this.isLoading = false;
          console.log(response);
          console.log('Added : ' + JSON.stringify(response.data));
          // on récupère l'objet sinon la premiére MAJ échoue...
          this.getModelObject();
        })
        .catch((err) => {
          this.isLoading = false;
          console.log(err.response);
        })
    },




    updateModelObject: function(postedObject) {
      
      console.log('ERRORS : ' + this.$validator.errors.all())
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.isLoading = true;
          var req_url = this.api_url 
          console.log("URL d'update : " + req_url)
          console.log("Changement sur l'objet : " + postedObject);
          console.log(postedObject)

          /*
          Methode afin de ne pas avoir d'erreur lorsque l'objet contient un champ de type fichier.
          NOTE : Depuis le frontend, ce champ est une chaîne de caractère. 
          Par conséquent, si l'on PUT cet objet, Django DRF refuse car le champ doit être un fichier et non une chaîne.

          Méthode :
          1- on créé un array 'file_names' qui contient la liste des properties de type fichier.
          2- on créé un objet temporaire que l'on va manipuler puis poster
          3- on recherche si l'objet que l'on veut poster contient un champ nommé comme l'un des éléments de l'array 'file_names'
          3.1- SI c'est le cas, on verifie si c'est un champ de TYPE fichier (là on fait rien encore)
          3.2- SI ce champ n'est pas null, on l'exclu de l'objet (ça semble se transformer en PATCH...)
          3.3- SI le champ est null, c'est pas grave, on le PUT as it.
          */
          var tempObject = postedObject;
          for (var prop in postedObject) {
            console.log(prop)
            this.file_names.forEach(function(item ) {
              console.log('exprop : ' + item)
              if (prop == item) {
                console.log('ex ===> ' + prop)
                if (prop instanceof File) {
                  console.log('FILE!')
                }
                else {
                  if (prop != null) {
                    console.log(prop + " n'est pas null!");
                    delete tempObject[prop]
                  }

                }
              }
            })
          }
        
          
          session.put(req_url, tempObject)
          // recupérer la réponse afin d'updater l'objet dynamiquement.
            .then((response) => {
              this.isLoading = false;
              this.modelObject = response.data;
            })
            .catch((err) => {
              this.isLoading = false;
              if (err.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              console.log('======= updateModelObject error in response =======')
              console.log(err.response.data);
              console.log(err.response.status);
              console.log(err.response.headers);
              } else if (err.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              console.log('======= updateModelObject error in request =======')
              console.log(err.request);
              } else {
              // Something happened in setting up the request that triggered an Error
              console.log('======= updateModelObject error in else =======')
              console.log('Err', err.message);
              }
            })
        }
        else {
          console.log('Vee-Validate. Pas de soumission !!!')
        }



      });


    },
  },
  mounted: function() {
    console.log('---- One Mounted called master ----> '+ this.api_url )
    this.getModelObject();
  },
})
